<template>
    <dv-full-screen-container>
        <div class="linea-mainContainer">
            <div class="mainHead">
                <div class="headLeft">
                    <dv-decoration-8 :color="['#47A8ED', '#47A8ED']" style="width: 500px; height: 50px" />
                </div>
                <div class="middleOfHead">
                    <div class="headerText">
                        <img alt="塑业实时数据大屏" src="@/assets/img/logo.png" />
                        <p>塑业实时数据大屏</p>
                    </div>
                    <dv-decoration-5 :color="['#47A8ED', '#47A8ED']" :dur="10" style="width: 700px; height: 40px" />
                </div>
                <div class="headRight">
                    <dv-decoration-8
                        :color="['#47A8ED', '#47A8ED']"
                        :reverse="true"
                        style="width: 500px; height: 50px"
                    />
                </div>
            </div>
            <div class="contentBox">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="leftBox">
                            <div class="upperLeft">
                                <dv-border-box-12 :color="['#0E4E80', '#1A92E8']" backgroundColor="rgba(5,21,57,0.3)">
                                    <div class="upperLeftBox">
                                        <div class="titleGroup">
                                            <div class="titleBox">电机控制台</div>
                                            <div class="toggleButtonGroup">
                                                <a
                                                    :class="motorTabActive === 0 ? 'toggleActivation' : ''"
                                                    @click="motorTabActive = 0"
                                                >
                                                    实时值
                                                </a>
                                                <span>丨</span>
                                                <a
                                                    :class="motorTabActive === 1 ? 'toggleActivation' : ''"
                                                    @click="motorTabActive = 1"
                                                >
                                                    设定值
                                                </a>
                                            </div>
                                        </div>
                                        <div v-if="motorTabActive === 0" class="contentGroup">
                                            <li>
                                                <p>
                                                    主机速度实时值：
                                                    <span>{{ Number(lineE.motor.data100).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    主机转矩A：
                                                    <span>{{ Number(lineE.motor.data101).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    主机转矩%：
                                                    <span>{{ Number(lineE.motor.data102).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    牵引速度实时：
                                                    <span>{{ Number(lineE.motor.data104).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    牵引转矩实时：
                                                    <span>{{ Number(lineE.motor.data105).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    共挤速度实时：
                                                    <span>{{ Number(lineE.motor.data115).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    供挤转矩实时：
                                                    <span>{{ Number(lineE.motor.data132).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    挤出产量实时：
                                                    <span>{{ Number(lineE.motor.data107).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    每米重实时：
                                                    <span>{{ Number(lineE.motor.data108).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    速比：
                                                    <span>{{ Number(lineE.motor.data106).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    熔体温度：
                                                    <span>{{ Number(lineE.xian.tc20).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    熔体温度℃：
                                                    <span>{{ Number(lineE.xian.tc120).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    熔体压力：
                                                    <span>{{ Number(lineE.motor.data103).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                        </div>
                                        <div v-if="motorTabActive === 1" class="contentGroup">
                                            <li>
                                                <p>
                                                    主机速度设定值：
                                                    <span>{{ Number(lineE.motor.data1).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    牵引速度设定：
                                                    <span>{{ Number(lineE.motor.data10).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    共挤速度设定：
                                                    <span>{{ Number(lineE.motor.data114).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    挤出产量设定：
                                                    <span>{{ Number(lineE.motor.data11).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                        </div>
                                    </div>
                                </dv-border-box-12>
                            </div>
                            <div class="lowerLeft">
                                <dv-border-box-12 :color="['#0E4E80', '#1A92E8']" backgroundColor="rgba(5,21,57,0.3)">
                                    <div class="lowerLeftBox">
                                        <div class="titleGroup">
                                            <div class="titleBox">参数信息</div>
                                        </div>
                                        <ul v-if="infoTabActive === 0" class="contentGroup">
                                            <li>
                                                <p>
                                                    主机最高速度：
                                                    <span>{{ lineE.motor.data2 }}</span>
                                                </p>
                                                <p>
                                                    主机最大电流：
                                                    <span>{{ lineE.motor.data3 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    牵引最高速度：
                                                    <span>{{ lineE.motor.data126 }}</span>
                                                </p>
                                                <p>
                                                    熔体最高压力：
                                                    <span>{{ lineE.motor.data127 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    主机报警转矩：
                                                    <span>{{ lineE.motor.data4 }}</span>
                                                </p>
                                                <p>
                                                    主机停机转矩：
                                                    <span>{{ lineE.motor.data5 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    供挤最高速度：
                                                    <span>{{ lineE.motor.data128 }}</span>
                                                </p>
                                                <p>
                                                    保温时间：
                                                    <span>{{ lineE.motor.data9 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    主机微调系数：
                                                    <span>{{ Number(lineE.motor.data6).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    牵引微调系数：
                                                    <span>{{ lineE.motor.data129 }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    报警压力：
                                                    <span>{{ lineE.motor.data7 }}</span>
                                                </p>
                                                <p>
                                                    停机压力：
                                                    <span>{{ lineE.motor.data8 }}</span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </dv-border-box-12>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="middleBox">
                            <div class="upperMiddle">
                                <line-change-moudle />
                                <div class="floorPlan">
                                    <img alt="" src="../../assets/img/plan/plan@2x.png" />
                                </div>
                            </div>
                            <div class="middleDown">
                                <dv-border-box-11 :color="['#47A8ED', '#2972A6']" title="温度观测台">
                                    <div class="swiper-box">
                                        <swiper ref="mySwiper" :options="swiperOptions">
                                            <swiper-slide>
                                                <div class="temperatureGroup">
                                                    <template v-for="index in 6">
                                                        <temp-e
                                                            :key="'e1' + index"
                                                            :name="`EH${index}`"
                                                            :choose="lineE.sw[`eeh${index}sw`]"
                                                            :start-stop="lineE.sw[`sw${index}`]"
                                                            :heating-state="lineE.sw[`sw${index}`]"
                                                            :set-temp="lineE.xian[`tc${index}`]"
                                                            :current-temp="lineE.xian[`tc${index + 100}`]"
                                                        />
                                                    </template>
                                                    <temp-e
                                                        name="EA1"
                                                        :choose="lineE.sw.eea1sw"
                                                        :start-stop="lineE.sw.sw7"
                                                        :heating-state="lineE.sw.sw7"
                                                        :set-temp="lineE.xian.tc7"
                                                        :current-temp="lineE.xian.tc107"
                                                    />
                                                    <template v-for="index in 3">
                                                        <temp-e
                                                            :key="'e2' + index"
                                                            :name="`ED${index}`"
                                                            :choose="lineE.sw[`eed${index}sw`]"
                                                            :start-stop="lineE.sw[`sw${index + 7}`]"
                                                            :heating-state="lineE.sw[`sw${index + 7}`]"
                                                            :set-temp="lineE.xian[`tc${index + 7}`]"
                                                            :current-temp="lineE.xian[`tc${index + 107}`]"
                                                        />
                                                    </template>
                                                </div>
                                            </swiper-slide>
                                            <swiper-slide>
                                                <div class="temperatureGroup">
                                                    <template v-for="index in 5">
                                                        <temp-e
                                                            :key="'e3' + index"
                                                            :name="`ED${index + 3}`"
                                                            :choose="lineE.sw[`eed${index + 3}sw`]"
                                                            :start-stop="lineE.sw[`sw${index + 10}`]"
                                                            :heating-state="lineE.sw[`sw${index + 10}`]"
                                                            :set-temp="lineE.xian[`tc${index + 10}`]"
                                                            :current-temp="lineE.xian[`tc${index + 110}`]"
                                                        />
                                                    </template>
                                                    <template v-for="index in 3">
                                                        <temp-e
                                                            :key="'e4' + index"
                                                            :name="`GEH${index}`"
                                                            :choose="lineE.sw[`egeh${index}sw`]"
                                                            :start-stop="lineE.sw[`sw${index + 15}`]"
                                                            :heating-state="lineE.sw[`sw${index + 15}`]"
                                                            :set-temp="lineE.xian[`tc${index + 15}`]"
                                                            :current-temp="lineE.xian[`tc${index + 115}`]"
                                                        />
                                                    </template>
                                                    <temp-e
                                                        name="GED1"
                                                        :choose="lineE.sw.eged1sw"
                                                        :start-stop="lineE.sw.sw19"
                                                        :heating-state="lineE.sw.sw19"
                                                        :set-temp="lineE.xian.tc19"
                                                        :current-temp="lineE.xian.tc119"
                                                    />
                                                </div>
                                            </swiper-slide>
                                            <div slot="pagination" class="paginationDiy swiper-pagination"></div>
                                        </swiper>
                                    </div>
                                </dv-border-box-11>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="rightBox">
                            <div class="upperRight" style="height: 100%">
                                <dv-border-box-12 :color="['#0E4E80', '#2972A6']" backgroundColor="rgba(5,21,57,0.3)">
                                    <div class="upperRightBox">
                                        <div class="titleBox">米重控制台</div>
                                        <div class="contentGroup">
                                            <li>
                                                <p>
                                                    每米重设定值：
                                                    <span>{{ Number(lineE.motor.data12).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    挤出产量设定值：
                                                    <span>{{ Number(lineE.motor.data11).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    主机转速设定值：
                                                    <span>{{ Number(lineE.motor.data1).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    牵引速度设定：
                                                    <span>{{ Number(lineE.motor.data10).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    共挤速度设定：
                                                    <span>{{ Number(lineE.motor.data114).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    主机转矩：
                                                    <span>{{ Number(lineE.motor.data102).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    熔体压力：
                                                    <span>{{ Number(lineE.motor.data103).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    每米重实时：
                                                    <span>{{ Number(lineE.motor.data107).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    挤出产量实时：
                                                    <span>{{ Number(lineE.motor.data106).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    主机转速实时：
                                                    <span>{{ Number(lineE.motor.data100).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    牵引速度实时：
                                                    <span>{{ Number(lineE.motor.data104).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    共挤速度实时：
                                                    <span>{{ Number(lineE.motor.data115).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    管材外径设定：
                                                    <span>{{ Number(lineE.motor.data116).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    管材密度设定：
                                                    <span>{{ Number(lineE.motor.data117).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    平均壁厚设定：
                                                    <span>{{ Number(lineE.motor.data118).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    平均壁厚实时：
                                                    <span>{{ Number(lineE.motor.data118).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    每米重设定：
                                                    <span>{{ Number(lineE.motor.data12).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    挤出产量设定：
                                                    <span>{{ Number(lineE.motor.data11).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    累计产量：
                                                    <span>{{ Number(lineE.motor.data113).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    当班产量：
                                                    <span>{{ Number(lineE.motor.data112).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    每米重实时：
                                                    <span>{{ Number(lineE.motor.data108).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    挤出产量实时：
                                                    <span>{{ Number(lineE.motor.data106).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    空料斗重量设定值：
                                                    <span>{{ Number(lineE.motor.data109).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    校准系数设定值：
                                                    <span>{{ Number(lineE.motor.data122).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    接近开关数设定值：
                                                    <span>{{ Number(lineE.motor.data123).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    牵引稳定系数：
                                                    <span>{{ Number(lineE.motor.data124).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    编码器校准系数设定值：
                                                    <span>{{ Number(lineE.motor.data125).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    米重调整比例设定值：
                                                    <span>{{ Number(lineE.motor.data119).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    米重调整时间0.1s设定值：
                                                    <span>{{ Number(lineE.motor.data120).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    米重调整区间设定值：
                                                    <span>{{ Number(lineE.motor.data121).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    米重调整等待区间设定值：
                                                    <span>{{ Number(lineE.motor.data130).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    牵引精度范围%设定值：
                                                    <span>{{ Number(lineE.motor.data131).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    空料斗重量实时值：
                                                    <span>{{ Number(lineE.motor.data109).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    校准系数实时值：
                                                    <span>{{ Number(lineE.motor.data122).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    接近开关数实时值：
                                                    <span>{{ Number(lineE.motor.data123).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    牵引稳定系数实时值：
                                                    <span>{{ Number(lineE.motor.data124).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    当前AD值：
                                                    <span>{{ Number(lineE.motor.data110).toFixed(2) }}</span>
                                                </p>
                                                <p>
                                                    当前下料率：
                                                    <span>{{ Number(lineE.motor.data111).toFixed(2) }}</span>
                                                </p>
                                            </li>
                                        </div>
                                    </div>
                                </dv-border-box-12>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </dv-full-screen-container>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
import { GET_LINE_E } from "@/api/public";
import TempE from "./components/Temp/TempEF.vue";
import LineChangeMoudle from "./components/LineChangeMoudle.vue";

export default {
    name: "LineC",
    components: {
        Swiper,
        SwiperSlide,
        TempE,
        LineChangeMoudle
    },
    data() {
        return {
            lineE: {
                motor: {
                    data1: 0,
                    data2: 0,
                    data3: 0,
                    data4: 0,
                    data5: 0,
                    data6: 0,
                    data7: 0,
                    data8: 0,
                    data9: 0,
                    data10: 0,
                    data11: 0,
                    data12: 0,
                    data100: 0,
                    data101: 0,
                    data102: 0,
                    data103: 0,
                    data104: 0,
                    data105: 0,
                    data106: 0,
                    data107: 0,
                    data108: 0,
                    data109: 0,
                    data110: 0,
                    data111: 0,
                    data112: 0,
                    data113: 0,
                    data114: 0,
                    data115: 0,
                    data116: 0,
                    data117: 0,
                    data118: 0,
                    data119: 0,
                    data120: 0,
                    data121: 0,
                    data122: 0,
                    data123: 0,
                    data124: 0,
                    data125: 0,
                    data126: 0,
                    data127: 0,
                    data128: 0,
                    data129: 0,
                    data130: 0,
                    data131: 0,
                    data132: 0
                },
                line: {},
                xian: {},
                sw: {}
            },
            swiperOptions: {
                autoplay: true,
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                }
            },
            // 切料控制台tab
            cuttingTabActive: 0,
            // 参数信息tab
            infoTabActive: 0,
            // 电机控制台tab
            motorTabActive: 0
        };
    },
    mounted() {
        this.getLineE();
        setInterval(() => {
            this.getLineE();
        }, 60000);
    },
    methods: {
        getLineE() {
            GET_LINE_E({}).then((res) => {
                if (Number(res.data.code) !== 10000) {
                    this.$message.error(res.data.message);
                    return false;
                }
                this.lineE = res.data.data;
                console.log(res.data.data);
            });
        }
    }
};
</script>

<style lang="scss">
@import "../../assets/style/lineA.scss";
</style>
